// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3iLVb","calendarButtons":"ClockData_calendarButtons__34SXT"};